import { MonitoringForm } from '../components/organisms/monitor/containers';
import request from '../utils/axios/request';
import { changeFileName } from '../utils/file';
import { PaginationContent } from '../utils/types/pagination';
import { QueryClient } from './Client.service';
import { IContainer } from './Container.service';

export interface IMonitoring {
	id?: number;
	id_container: number;
	temperature: number | null;
	observation: string;
	humidity?: number;
	ventilation?: number;
	atmosferaControlada?: boolean;
	nivelCo2?: number | string | null;
	return?: number;
	supply?: number;
	images?: string[];
	imgFiles: File[];
	problems: number[];
	created_at?: Date;
	updated_at?: Date;
	container?: IContainer;
}

export interface MonitoringR {
	id: number;
	container: string;
	date: string;
	setPoint: number;
	temperature: number;
	travelCode: string;
	checked: boolean;
	actions: any;
}

abstract class MonitoringService {
	static async create(data: IMonitoring[]) {
		const formData = new FormData();
		formData.append('data', JSON.stringify({ data }));

		for (let item of data) {
			if (item.imgFiles && item.imgFiles.length > 0) {
				item.imgFiles.forEach((image) => {
					const fileName = `${item.id_container}_${image.name}`;
					if (image instanceof File) {
						const modifiedFile = new File([image], fileName, {
							type: image.type,
						});
						formData.append('images', modifiedFile);
					}
				});
			}
		}

		try {
			const response = await request('/monitoring', 'post', {
				data: formData,
				headers: {
					'Content-Type': 'multipart/form-data',
				},
			});
			return response;
		} catch (error: any) {}
	}

	static async getAllByYard(yardId: number) {
		try {
			const response = await request(
				`/monitoring/yard/latest/${yardId}`,
				'get'
			);
			return response;
		} catch (error: any) {}
	}

	static async getAllByOwner(owner: string) {
		try {
			const response: MonitoringForm[] = await request(
				`/monitoring/owner/${owner}`,
				'get'
			);
			return response;
		} catch (error: any) {}
	}

	static async getAllAuditory(
		params: QueryClient,
		yardId?: number,
		date?: Date
	): Promise<PaginationContent<MonitoringR> | undefined> {
		try {
			const response: PaginationContent<MonitoringR> = await request(
				'/monitoring/auditory',
				'get',
				{
					params: {
						yardId,
						date: date ? date.toISOString() : undefined,
						...params,
					},
				}
			);
			return response;
		} catch (error: any) {}
	}
}

export default MonitoringService;
